import axios from "axios";
import React, { useEffect, useState } from "react";
import { HEADER } from "../../utils/Utils";
import ModalLoading from "../../components/ModalLoading";
import ModalUser from "../../components/Modal/ModalUser";
import CardUser from "../../components/Card/CardUser";
import _ from "lodash";
import ModalDelete from "../../components/Modal/ModalDelete";

export default function UserDetailsFragment({ dataUser, dataOutlet }) {
   const [users, setUsers] = useState([]);

   // state modal
   const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
      useState(false);
   const [showModalLoading, setShowModalLoading] = useState(false);
   const [showModalUser, setShowModalUser] = useState(false);
   const [modalUserDetails, setModalUserDetails] = useState({
      title: "Add User",
      type: "Add",
   });

   // state loading
   const [buttonLoading, setButtonLoading] = useState(false);

   // state input user
   const [inputUser, setInputUser] = useState({});

   useEffect(() => {
      GetDataUsers();
      return () => {
         setUsers([]);
      };
   }, []);

   async function GetDataUsers() {
      setShowModalLoading(true);
      try {
         let list_users = await axios.get(
            `${process.env.REACT_APP_BASE_URL_API}/v2/collection/akuisisi/data?channel_id=${dataOutlet.channel_id}`,
            { headers: HEADER }
         );
         list_users = list_users.data.data;
         setUsers(list_users);
      } catch (error) {
         console.error(error);
         setShowModalLoading(false);
      }
      setShowModalLoading(false);
   }

   async function AddUser() {
      setShowModalLoading(true);
      // field_required
      let body = {
         user_type: "member",
         ...inputUser,
      };

      await axios
         .post(`${process.env.REACT_APP_BASE_URL_API}/akuisisi`, body, {
            headers: HEADER,
         })
         .catch((error) => {
            console.error(error);
            setShowModalLoading(false);
         });
      GetDataUsers();
      setShowModalUser(false);
      setShowModalLoading(false);
   }

   async function EditUser(body) {
      setShowModalLoading(true);

      await axios
         .put(
            `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${body.akuisisi_id}`,
            body,
            {
               headers: HEADER,
            }
         )
         .catch((error) => {
            console.error(error);
            setShowModalLoading(false);
         });
      GetDataUsers();
      setShowModalUser(false);
      setShowModalLoading(false);
   }

   async function DeleteUser() {
      setButtonLoading(true);
      let id = modalUserDetails.id;
      await axios
         .delete(`${process.env.REACT_APP_BASE_URL_API}/akuisisi/${id}`, {
            headers: HEADER,
         })
         .catch((error) => {
            console.error(error);
            setButtonLoading(false);
            setShowDeleteConfirmationModal(false);
         });
      GetDataUsers();
      setButtonLoading(false);
      setShowDeleteConfirmationModal(false);
   }

   function ShowDeleteModal(id) {
      setModalUserDetails({
         title: "Delete User",
         type: "Delete",
         id: id,
      });
      setShowDeleteConfirmationModal(true);
   }

   function ShowEditModal(data) {
      setInputUser(data);
      setShowModalUser(true);
      setModalUserDetails({
         title: "Edit User",
         type: "Edit",
      });
   }

   return (
      <>
         <ModalDelete
            title="User"
            showDeleteConfirmationModal={showDeleteConfirmationModal}
            setShowDeleteConfirmationModal={setShowDeleteConfirmationModal}
            DeleteFunction={DeleteUser}
            buttonLoading={buttonLoading}
         />
         <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         />
         <ModalUser
            modalUserDetails={modalUserDetails}
            showModal={showModalUser}
            setShowModal={setShowModalUser}
            inputUser={inputUser}
            setInputUser={setInputUser}
            dataUser={dataUser}
            functionAdd={AddUser}
            functionEdit={EditUser}
            dataOutlet={dataOutlet}
         />
         <div className="flex justify-between items-center">
            <h2 className="font-medium text-gray-700">Users</h2>
            <button
               className="btn-sm bg-[#4CA6F8] text-white"
               onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setInputUser({});
                  setShowModalUser(true);
                  setModalUserDetails({
                     title: "Add User",
                     type: "Add",
                  });
               }}
            >
               <svg
                  className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
                  viewBox="0 0 16 16"
               >
                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
               </svg>
               <span className="ml-2">Add User</span>
            </button>
         </div>
         <div className="overflow-y-scroll mt-4">
            <div className="space-y-3">
               {_.isEmpty(users) ? (
                  <div className="w-full h-28 border-dashed border-2">
                     <div className="w-full h-full flex items-center justify-center space-x-2">
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           fill="none"
                           viewBox="0 0 24 24"
                           strokeWidth={1.5}
                           stroke="currentColor"
                           className="w-5 h-5 text-gray-400"
                        >
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                           />
                        </svg>
                        <span className="text-sm text-gray-400">
                           You don't have an user
                        </span>
                     </div>
                  </div>
               ) : (
                  users.map((user) => (
                     <CardUser
                        data={user}
                        enActionEdit={user.user_type === "member"}
                        enActionDelete={user.user_type === "member"}
                        isDisable={false}
                        editFunction={ShowEditModal}
                        deleteFunction={ShowDeleteModal}
                     />
                  ))
               )}
            </div>
         </div>
      </>
   );
}
